import { Injectable } from '@angular/core';
import { bookCacheName } from './offline-keys';

/**
 * Book content stored for offline reading, one Cache API cache per loan. Chapters are stored as
 * the server sends them (AES-encrypted).
 */
@Injectable({
  providedIn: 'root',
})
export class BookContentCache {
  private readonly storage: CacheStorage | undefined =
    typeof caches === 'undefined' ? undefined : caches;

  isSupported(): boolean {
    return this.storage !== undefined;
  }

  async put(loanKey: string, url: string, response: Response): Promise<void> {
    const cache = await this.open(loanKey);
    await cache.put(url, response);
  }

  async match(loanKey: string, url: string): Promise<Response | undefined> {
    const cache = await this.open(loanKey);
    return cache.match(url);
  }

  async delete(loanKey: string): Promise<void> {
    await this.storage?.delete(bookCacheName(loanKey));
  }

  private async open(loanKey: string): Promise<Cache> {
    if (!this.storage) throw new Error('Cache API not available');
    return this.storage.open(bookCacheName(loanKey));
  }
}
